import AttachmentViewState from '../schema/AttachmentViewState';
import ImageLoadState from '../schema/ImageLoadState';
import { action } from 'satcheljs/lib/legacy';

export default action('setThumbnailLoadState')(function setThumbnailLoadState(
    attachment: AttachmentViewState,
    newState: ImageLoadState
) {
    attachment.thumbnailLoadState = newState;
});
